import { cachedGet } from "../cache";
import { API_ENDPOINTS } from "../endpoints";
import type {
  ApiResponse,
  SearchParams,
  SearchResults,
} from "../interface";

export const searchService = {
  async search(params: SearchParams) {
    return cachedGet<ApiResponse<SearchResults>>(
      API_ENDPOINTS.search,
      { params }
    );

  },
};
